export default {
    title: 'text-120 leading-tight font-semibold mb-80',
    titleGreen:  'text-green-500 ml-15 inline-block leading-none',
    titleGreenNoMargin:  'text-green-500 ml-15 inline-block leading-none',

    button: 'inline-block bg-green-500 text-30 text-white py-30 px-80',


    circleGreen: 'rounded-full inline-flex justify-center items-center w-100 h-100 bg-green-500',
    circleBlack: 'rounded-full inline-flex justify-center items-center w-100 h-100 bg-black',
}
